
/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";
import Box from '@mui/material/Box';
import getSpecific from "../../lib/api/getSpecific";
import TkPopMaterialAcquisitionButton from "../input/TkPopMaterialAcquisitionButton";
import TkPopProduceEndButton from "../input/TkPopProduceEndButton";
import TkPopProductManageDetail from "./TkPopProductManageDetail";
import TkPopQCButton from "../input/TkPopQCButton";
import { debounce } from "lodash";
import defineConf from "../../config/defineConf";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkPopNoticeDisplay from "./TkPopNoticeDisplay";
import TkPopMaterialAcquisitionBulkButton from "../input/TkPopMaterialAcquisitionBulkButton";
import TkPopProduceEndBulkButton from "../input/TkPopProduceEndBulkButton";

function TkPopProductManage(props) {

    const {
        id,
    } = props;

    const table = "TkPopProductManage";

    const view = "TkVwPopProductManage";

    const [grid, setGrid] = useState();

    const [onSelectMst, setOnSelectMst] = useState();

    const [height, setHeight] = useState(0);

    const { t } = useTranslation();

    const [api, setApi] = useState();

    const [, setDetailApi] = useState();

    const [isEmpty, setIsEmpty] = useState();

    const [inProgress, setInProgress] = useState();

    const [endProcessComplete, setEndProcessComplete] = useState();

    const [queries, setQueries] = useState({ $button: null });

    const [trigger, setTrigger] = useState(false);

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        if (api) {

            api.refresh();

        }

    }, [id]);

    useEffect(() => {

        let id;

        if (!trigger) {

            id = setInterval(() => {

                if (api) {

                    api.refresh();

                }

            }, 3 * 100000);

        } else {

            clearInterval(id);

        }
        return () => {

            clearInterval(id);

        }

    }, [trigger, api])

    const onTrigger = (trigger) => {

        setTrigger(trigger);

    }

    useEffect(() => {

        window.addEventListener('resize', handleResize);

        handleResize();

        return (() => {

            window.removeEventListener('resize', handleResize);

        });

    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([])

                    }

                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([])

                    }

                }), 10);

                grid.refreshed.addHandler((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst((pre) => { // 참조 변경
                            let newData = {
                                ...pre,
                                ...grid.selectedItems[0]
                            }
                            return newData
                        })

                    } else {

                        setOnSelectMst([])

                    }

                });
            }

        })()

    }, [grid]);

    useEffect(() => {

        (async () => {

            if (onSelectMst) {

                let processByParentPlan = await getSpecific("TkVwPopProductManage/TkVwPopProcessByParentPlanId", onSelectMst.parentPlanId);

                let progress = processByParentPlan?.data.some(v => 
                    ([defineConf.produceStatus.WORKING, defineConf.produceStatus.HOLDING, defineConf.produceStatus.ACQUIRED].includes(parseInt(v.produceStatus)) 
                    && v.processCode !== "PR010")
                    || v.outSourcingLot === true
                );

                setInProgress(progress);

                let endProcess = processByParentPlan?.data.find(v => v.processCode === "PR_END");

                setEndProcessComplete(endProcess?.completed);

            }

        })();

    }, [onSelectMst]);

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const onInitialized = grid => {

        grid.selectionMode = "Row";

        setGrid(grid);

    };

    const detailApiInitialized = api => {

        setDetailApi(api);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const onUpdateMaster = () => {

        setDetailApi((api) => {

            if (api) {

                api.refresh();

            }

            return api;

        })

        setGrid((grid) => {

            if (grid) {

                (async () => {

                    let ProductMst = await getSpecific("TkVwPopProductManage", grid.selectedItems[0].planId);

                    if (ProductMst) {

                        for (let x in grid?.selectedItems[0]) {

                            grid.selectedItems[0][x] = ProductMst[x]

                        }

                    }

                    for (let v of grid.itemsSource.items) {

                        if (v.parentPlanId === grid.itemsSource.currentItem.parentPlanId) {

                            v.resultLotNo = grid.itemsSource.currentItem.resultLotNo;

                            v.qtyCurrent = grid.itemsSource.currentItem.qtyCurrent;

                        }

                    }

                    grid.refresh(false);

                })();

            }

            return grid;

        })

    }

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

        if (onUpdateMaster) {

            onUpdateMaster();

        }

    };

    const onSuccessRefresh = (msg) => {

        notifySuccess(msg);

        if (api) {

            api.refresh();

        }

        setDetailApi((api) => {

            if (api) {

                api.refresh();

            }

            return api;

        })

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const doHandleBackendErrorMsg = (reason) => {

        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;

    };

    const onModifyViewUrl = (url, id) => {

        return url + "/category/" + id;

    };

    const onButtonFilter = (param) => {

        let condition = null;

        if (param !== queries.$button) condition = param;

        setQueries({ $button: condition });

    }

    const onAppendButtonAtLast = () => {
        return (
            <>
                <BasicCrudScreenActionItemLayout>
                    <CreateRecordButtonLayout
                        id={id + "-today-button"}
                        createButtonName={"todayWork"}
                        onClick={() => onButtonFilter(defineConf.buttonFilterIndex.TODAY)}
                        color={queries.$button === defineConf.buttonFilterIndex.TODAY ? "secondary" : "primary"}
                    />
                    <CreateRecordButtonLayout
                        id={id + "-tomorrow-button"}
                        createButtonName={"tomorrowWork"}
                        onClick={() => onButtonFilter(defineConf.buttonFilterIndex.TOMORROW)}
                        color={queries.$button === defineConf.buttonFilterIndex.TOMORROW ? "secondary" : "primary"}
                    />
                    <CreateRecordButtonLayout
                        id={id + "-unworked-button"}
                        createButtonName={"unworked"}
                        onClick={() => onButtonFilter(defineConf.buttonFilterIndex.UNWORKED)}
                        color={queries.$button === defineConf.buttonFilterIndex.UNWORKED ? "secondary" : "primary"}
                    />
                    <CreateRecordButtonLayout
                        id={id + "-working-button"}
                        createButtonName={"working"}
                        onClick={() => onButtonFilter(defineConf.buttonFilterIndex.WORKING)}
                        color={queries.$button === defineConf.buttonFilterIndex.WORKING ? "secondary" : "primary"}
                    />
                    <CreateRecordButtonLayout
                        id={id + "-popAll-button"}
                        createButtonName={"popAll"}
                        onClick={() => onButtonFilter(defineConf.buttonFilterIndex.POPALL)}
                        color={queries.$button === defineConf.buttonFilterIndex.POPALL ? "secondary" : "primary"}
                    />
                </BasicCrudScreenActionItemLayout>
            </>
        );
    }

    const onAppendButtonInFrontOfSearch = () => {
        if (id === "PopAll") return <></>;
        return (
            <>
                <BasicCrudScreenActionItemLayout>
                    <TkPopMaterialAcquisitionBulkButton
                        createButtonName={"acquisitionBulk"}
                        onSuccess={onSuccessRefresh}
                        onTrigger={onTrigger}
                        customizeErrorMsgCallback={doHandleBackendErrorMsg}
                        disabled={isEmpty}
                        id={id}
                    />
                    <TkPopMaterialAcquisitionButton
                        createButtonName={"acquisition"}
                        onSelectMst={onSelectMst}
                        onSuccess={onSuccess}
                        onTrigger={onTrigger}
                        customizeErrorMsgCallback={doHandleBackendErrorMsg}
                        disabled={!([defineConf.produceStatus.UNWORKED, defineConf.produceStatus.COMPLETION]).includes(parseInt(onSelectMst?.produceStatus)) || endProcessComplete || (inProgress && id !== "ElectrodeProcessing") || isEmpty}
                        id={id}
                    />
                    {
                        id !== "Measurement"
                            ?
                            <TkPopProduceEndBulkButton
                                createButtonName={"produceEndBulk"}
                                onSuccess={onSuccessRefresh}
                                onTrigger={onTrigger}
                                customizeErrorMsgCallback={doHandleBackendErrorMsg}
                                disabled={isEmpty}
                                id={id}
                            />
                            :
                            <></>
                    }
                    {
                        id !== "Measurement"
                            ?
                            <TkPopProduceEndButton
                                createButtonName={"produceEnd"}
                                onSelectMst={onSelectMst}
                                onSuccess={onSuccessRefresh}
                                onTrigger={onTrigger}
                                customizeErrorMsgCallback={doHandleBackendErrorMsg}
                                disabled={!([defineConf.produceStatus.WORKING, defineConf.produceStatus.HOLDING]).includes(parseInt(onSelectMst?.produceStatus)) || isEmpty}
                                id={id}
                            />
                            :
                            <TkPopQCButton
                                createButtonName={"qc"}
                                onSelectMst={onSelectMst}
                                onSuccess={onSuccessRefresh}
                                onFailure={onFailure}
                                onTrigger={onTrigger}
                                customizeErrorMsgCallback={doHandleBackendErrorMsg}
                                disabled={!([defineConf.produceStatus.WORKING, defineConf.produceStatus.HOLDING]).includes(parseInt(onSelectMst?.produceStatus)) || endProcessComplete || isEmpty}
                            />
                    }
                </BasicCrudScreenActionItemLayout>
            </>
        );
    }

    return (

        <div style={{ height: height }} >

            <ReflexContainer orientation="horizontal">

                <ReflexElement flex={0.65}>

                    <BasicCrudScreenType
                        id={table}
                        headerTitle={t(`term.${id}`)}
                        table={table}
                        view={view}
                        onInitialized={onInitialized}
                        onApiInitialized={onApiInitialized}
                        onLoadData={onLoadData}
                        onModifyViewUrl={(url) => onModifyViewUrl(url, id)}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        $queries={queries}
                        onAppendButtonAtLast={onAppendButtonAtLast}
                        onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}

                    />

                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement flex={0.35}>

                    {
                        (onSelectMst)
                            ?
                            <ReflexContainer orientation="vertical">

                                <ReflexElement flex={0.7}>

                                    <TkPopProductManageDetail
                                        id={id}
                                        idDetail={`${id}Detail`}
                                        view={`${view}Detail`}
                                        detailApiInitialized={detailApiInitialized}
                                        onSelectMst={onSelectMst}
                                        onMstEmpty = {isEmpty}
                                    />

                                </ReflexElement>

                                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                                <ReflexElement flex={0.3}>

                                    <Box component="div" padding={2} wordBreak="break-all">

                                        <TkPopNoticeDisplay
                                            workOrderNumber={onSelectMst.workOrderNumber}
                                            partNo={onSelectMst.partNo}
                                        ></TkPopNoticeDisplay>

                                    </Box>

                                </ReflexElement>

                            </ReflexContainer>
                            :
                            <></>
                    }

                </ReflexElement>

            </ReflexContainer>

        </div>

    );

}

export default TkPopProductManage;